import { apnsConfig, fcmConfig, expoConfig, oneSignalConfig, pushWebhookConfig } from '../credentials';
import { PushProviderIdEnum } from '../provider.enum';
import { ChannelTypeEnum } from '../../../types';
export const pushProviders = [
    {
        id: PushProviderIdEnum.OneSignal,
        displayName: 'OneSignal',
        channel: ChannelTypeEnum.PUSH,
        credentials: oneSignalConfig,
        docReference: 'https://documentation.onesignal.com/reference/create-notification',
        logoFileName: { light: 'one-signal.svg', dark: 'one-signal.svg' },
    },
    {
        id: PushProviderIdEnum.FCM,
        displayName: 'Firebase Cloud Messaging',
        channel: ChannelTypeEnum.PUSH,
        credentials: fcmConfig,
        docReference: 'https://docs.novu.co/channels/push/fcm',
        logoFileName: { light: 'fcm.svg', dark: 'fcm.svg' },
    },
    {
        id: PushProviderIdEnum.EXPO,
        displayName: 'Expo Push',
        channel: ChannelTypeEnum.PUSH,
        credentials: expoConfig,
        docReference: 'https://docs.novu.co/channels/push/expo',
        logoFileName: { light: 'expo.svg', dark: 'expo.svg' },
    },
    {
        id: PushProviderIdEnum.APNS,
        displayName: 'APNs',
        channel: ChannelTypeEnum.PUSH,
        credentials: apnsConfig,
        docReference: 'https://docs.novu.co/channels/push/apns',
        logoFileName: { light: 'apns.png', dark: 'apns.png' },
        betaVersion: true,
    },
    {
        id: PushProviderIdEnum.PushWebhook,
        displayName: 'Push Webhook',
        channel: ChannelTypeEnum.PUSH,
        credentials: pushWebhookConfig,
        docReference: 'https://docs.novu.co/channels/push/webhook',
        logoFileName: { light: 'push-webhook.svg', dark: 'push-webhook.svg' },
        betaVersion: true,
    },
];
